import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/articles";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isHome = location.pathname === "/";
  const isDarkHero = isHome;
  const showBg = scrolled || !isDarkHero;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        showBg
          ? "bg-background-50/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link
            to="/"
            className={`font-heading font-black text-xl md:text-2xl tracking-tight transition-colors ${
              showBg ? "text-foreground-950" : "text-white"
            }`}
          >
            53<span className="text-primary-500">吃瓜</span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors hover:text-primary-500 whitespace-nowrap ${
                showBg ? "text-foreground-800" : "text-white/90"
              } ${location.pathname === "/" ? "text-primary-500" : ""}`}
            >
              首页
            </Link>
            {categories.slice(0, 4).map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`text-sm font-medium transition-colors hover:text-primary-500 whitespace-nowrap ${
                  showBg ? "text-foreground-800" : "text-white/90"
                } ${location.pathname === `/category/${cat.slug}` ? "text-primary-500" : ""}`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors hover:text-primary-500 whitespace-nowrap ${
                showBg ? "text-foreground-800" : "text-white/90"
              } ${location.pathname === "/about" ? "text-primary-500" : ""}`}
            >
              关于我们
            </Link>
          </div>

          {/* Right Actions */}
          <div className="flex items-center gap-3 md:gap-4">
            <button
              className={`w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-full transition-colors ${
                showBg
                  ? "text-foreground-700 hover:bg-background-200"
                  : "text-white/90 hover:bg-white/10"
              }`}
              aria-label="搜索"
            >
              <i className="ri-search-line text-lg" />
            </button>
            <Link
              to="/about"
              className={`hidden sm:inline-flex items-center px-4 py-2 rounded-full text-sm font-medium border transition-colors whitespace-nowrap ${
                showBg
                  ? "border-foreground-800 text-foreground-800 hover:bg-foreground-800 hover:text-background-50"
                  : "border-white/60 text-white hover:bg-white hover:text-foreground-950"
              }`}
            >
              联系我们
            </Link>
            {/* Mobile menu button */}
            <button
              className={`lg:hidden w-9 h-9 flex items-center justify-center rounded-full transition-colors ${
                showBg
                  ? "text-foreground-700 hover:bg-background-200"
                  : "text-white/90 hover:bg-white/10"
              }`}
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="菜单"
            >
              <i className={`ri-${mobileOpen ? "close" : "menu"}-line text-xl`} />
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="lg:hidden bg-background-50/98 backdrop-blur-md border-t border-background-200">
          <div className="px-4 py-4 space-y-1">
            <Link
              to="/"
              onClick={() => setMobileOpen(false)}
              className="block px-4 py-3 rounded-xl text-foreground-800 font-medium hover:bg-background-100"
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                onClick={() => setMobileOpen(false)}
                className="block px-4 py-3 rounded-xl text-foreground-800 font-medium hover:bg-background-100"
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              onClick={() => setMobileOpen(false)}
              className="block px-4 py-3 rounded-xl text-foreground-800 font-medium hover:bg-background-100"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}